import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const UploadPrices = {
  state: {
    LOADING: false,
    ERRORMESSAGE: null,
    PRICES: [],
    EXCHANGERATES: [],
    priceDate: null,
    UploadedOn: null,
    FILELOADING: false,
    UPLOADLOG: "",
  },
  getters: {
    UPLOADPRICESLOADING: (state) => state.LOADING,
    UPLOADERROR: (state) => state.ERRORMESSAGE,
    GETPRICES: (state) => state.PRICES,
    PRICEDATE: (state) => state.priceDate,
    UPLOADON: (state) => state.UploadedOn,
    EXCHANGERATES: (state) => state.EXCHANGERATES,
    FILELOADING: (state) => state.FILELOADING,
    UPLOADLOG: (state) => state.UPLOADLOG,
  },
  actions: {
    [ACTIONS.GET_ALL_UPLOAD_PRICES]: (context, query) => {
      return new Promise((resolve, reject) => {
        var { commit } = context;
        var URL = query == null ? "?currentpage=1&pagesize=1&search=" : query;

        commit(ACTIONS.GET_ALL_UPLOAD_PRICES_PENDING);
        Api.get("Commodities/GetCommodityPrices" + URL, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.GET_ALL_UPLOAD_PRICES_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              //var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
    [ACTIONS.UPLOAD_COMMODITY_PRICES]: (context, data) => {
      return new Promise((resolve, reject) => {
        var { commit } = context;
        // context.commit(ACTIONS.VENDORS_SAVE_PENDING);
        // var params = new URLSearchParams();
        // params.append("Name", data.Name);
        // params.append("Address", data.Address);
        // params.append("ContactNo", data.ContactNo);
        // params.append("Email", data.Email);
        // params.append("AccNo", data.AccNo);
        // params.append("Type", data.VendorTypeObject);
        // params.append("Deleted", data.Deleted == false ? 0 : 1);
        // params.append("ContractDate", data.ContractDate);
        // params.append("Id", data.VendorId == null ? 0 : data.VendorId);
        commit(ACTIONS.UPLOAD_COMMODITY_PRICES_PENDING);
        let formData = new FormData();
        formData.append("file", data);
        Api.post("Commodities/UploadRates", formData, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
            "Content-Type": "multipart/form-data",
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.UPLOAD_COMMODITY_PRICES_SUCCESS);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR, data.StatusMessage);
            } else if (data && data.StatusCode == 450) {
              commit(
                ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR,
                "File does not exist",
              );
              return resolve(res);
            } else {
              commit(ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              //var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.GET_ALL_UPLOAD_PRICES_ERROR]: (state, msg) => {
      state.ERRORMESSAGE = msg;
      state.LOADING = false;
    },
    [ACTIONS.GET_ALL_UPLOAD_PRICES_SUCCESS]: (state, data) => {
      state.ERRORMESSAGE = null;
      state.LOADING = false;
      state.PRICES = data.commodityPrices;
      state.priceDate = data.priceDate;
      state.EXCHANGERATES = data.exchangeRates;
      state.UploadedOn = data.uploadedOn;
      state.ERRORMESSAGE = state.ERRORMESSAGE;
    },
    [ACTIONS.GET_ALL_UPLOAD_PRICES_PENDING]: (state) => {
      state.ERRORMESSAGE = null;
      state.LOADING = true;
    },
    [ACTIONS.UPLOAD_COMMODITY_PRICES_PENDING]: (state) => {
      state.ERRORMESSAGE = null;
      state.FILELOADING = true;
      state.UPLOADLOG = "Uploading file. . .";
    },
    [ACTIONS.UPLOAD_COMMODITY_PRICES_SUCCESS]: (state) => {
      state.ERRORMESSAGE = null;
      state.FILELOADING = false;
      state.UPLOADLOG = null;
    },
    [ACTIONS.UPLOAD_COMMODITY_PRICES_ERROR]: (state, msg) => {
      state.ERRORMESSAGE = msg;
      state.FILELOADING = false;
      state.UPLOADLOG = null;
    },
  },
};

export default UploadPrices;
